import { render, staticRenderFns } from "./SettingsPaymentPayoneerAccounts.vue?vue&type=template&id=335b4956&lang=pug&"
import script from "./SettingsPaymentPayoneerAccounts.vue?vue&type=script&lang=js&"
export * from "./SettingsPaymentPayoneerAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPaymentPayoneerAccounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335b4956')) {
      api.createRecord('335b4956', component.options)
    } else {
      api.reload('335b4956', component.options)
    }
    module.hot.accept("./SettingsPaymentPayoneerAccounts.vue?vue&type=template&id=335b4956&lang=pug&", function () {
      api.rerender('335b4956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayment/SettingsPaymentPayoneerAccounts.vue"
export default component.exports